import type { RagTableType } from './rag.js';

export const MAX_FOLDER_DEPTH = 6;

/**
 * Whether a folder at `depth` (root 0, bucket 1) may hold another folder; every
 * depth check goes through it.
 */
export const canNestAt = (depth: number) => depth < MAX_FOLDER_DEPTH;

export const ROOT_FOLDER_ID = '__kb_root__';

export const USERS_PRIVATE_FOLDERS_ID = '__kb_users_private__';

export const toApiFolderId = (folderId: string) =>
  folderId === ROOT_FOLDER_ID ? null : folderId;

/**
 * The folder whose listing backs the open page; the users' private folders
 * page is drawn from the root listing.
 */
export const toListedFolderId = (folderId: string) =>
  folderId === USERS_PRIVATE_FOLDERS_ID ? ROOT_FOLDER_ID : folderId;

export type NodeCreator = {
  firstName?: string | null;
  lastName?: string | null;
};

export type FolderNode = {
  kind: 'folder';
  id: string;
  name: string;
  description?: string;
  parentId: string;
  isBucket?: boolean;
  isSystem?: boolean;
  isPrivate?: boolean;
  createdAt?: string;
  owner?: NodeCreator;
  hasChildren?: boolean;
};

export type FileNode = { kind: 'file'; id: string } & RagTableType;

export type FileSystemNode = FolderNode | FileNode;

export type FolderCrumb = {
  folderId: string;
  name: string;
};
